export const client_data = [
  {
    clientName: "Mendy Bahago",
    subject: "Mathematics",
    startDate: "2023-05-12",
    endDate: "2024-02-18",
    status: "Ended",
    amountEarned: 876.45,
    classes: 12,
    rating: 4.5,
  },
  {
    clientName: "Benard Simon",
    subject: "Science",
    startDate: "2023-03-20",
    endDate: "2023-11-11",
    status: "Active",
    amountEarned: 432.99,
    classes: 8,
    rating: 4.8,
  },
  {
    clientName: "Alice Williams",
    subject: "History",
    startDate: "2023-06-01",
    endDate: "2024-04-05",
    status: "Pending",
    amountEarned: 275.32,
    classes: 15,
    rating: 3.9,
  },
  {
    clientName: "Bob Jones",
    subject: "Literature",
    startDate: "2023-02-10",
    endDate: "2023-12-24",
    status: "Cancelled",
    amountEarned: 123.45,
    classes: 5,
    rating: 2.7,
  },
  {
    clientName: "Charlie Brown",
    subject: "Art",
    startDate: "2023-08-18",
    endDate: "2024-06-30",
    status: "Ended",
    amountEarned: 654.75,
    classes: 10,
    rating: 4.2,
  },
  {
    clientName: "Karen Lewis",
    subject: "Economics",
    startDate: "2023-07-18",
    endDate: "2024-03-15",
    status: "Pending",
    amountEarned: 301.22,
    classes: 16,
    rating: 3.8,
  },
  {
    clientName: "Liam White",
    subject: "Philosophy",
    startDate: "2023-02-20",
    endDate: "2024-01-05",
    status: "Cancelled",
    amountEarned: 145.67,
    classes: 6,
    rating: 2.5,
  },
  {
    clientName: "Mia Harris",
    subject: "Psychology",
    startDate: "2023-09-01",
    endDate: "2024-07-01",
    status: "Ended",
    amountEarned: 712.89,
    classes: 13,
    rating: 4.4,
  },
  {
    clientName: "Noah Martin",
    subject: "Sociology",
    startDate: "2023-08-25",
    endDate: "2024-06-23",
    status: "Active",
    amountEarned: 432.32,
    classes: 11,
    rating: 4.2,
  },
  {
    clientName: "Olivia Thompson",
    subject: "Anthropology",
    startDate: "2023-01-30",
    endDate: "2023-10-20",
    status: "Pending",
    amountEarned: 523.45,
    classes: 19,
    rating: 4.3,
  },
  {
    clientName: "Paul Scott",
    subject: "Linguistics",
    startDate: "2023-06-11",
    endDate: "2024-04-10",
    status: "Ended",
    amountEarned: 654.32,
    classes: 17,
    rating: 4.6,
  },
  {
    clientName: "Quinn Hill",
    subject: "Statistics",
    startDate: "2023-04-07",
    endDate: "2024-02-02",
    status: "Cancelled",
    amountEarned: 234.56,
    classes: 4,
    rating: 3.2,
  },
  {
    clientName: "Ruby Green",
    subject: "Environmental Science",
    startDate: "2023-10-15",
    endDate: "2024-08-14",
    status: "Active",
    amountEarned: 789.78,
    classes: 21,
    rating: 4.9,
  },
  {
    clientName: "Daisy Davis",
    subject: "Music",
    startDate: "2023-01-25",
    endDate: "2023-10-15",
    status: "Active",
    amountEarned: 789.01,
    classes: 22,
    rating: 4.9,
  },
  {
    clientName: "Eve Miller",
    subject: "Computer Science",
    startDate: "2023-04-17",
    endDate: "2024-01-22",
    status: "Pending",
    amountEarned: 555.55,
    classes: 18,
    rating: 4.0,
  },
  {
    clientName: "Frank Wilson",
    subject: "Physical Education",
    startDate: "2023-09-05",
    endDate: "2024-07-16",
    status: "Ended",
    amountEarned: 321.23,
    classes: 7,
    rating: 3.5,
  },
  {
    clientName: "Grace Moore",
    subject: "Biology",
    startDate: "2023-07-21",
    endDate: "2024-05-29",
    status: "Cancelled",
    amountEarned: 210.76,
    classes: 3,
    rating: 2.9,
  },
  {
    clientName: "Hank Taylor",
    subject: "Chemistry",
    startDate: "2023-11-13",
    endDate: "2024-09-25",
    status: "Active",
    amountEarned: 678.89,
    classes: 20,
    rating: 4.6,
  },
  {
    clientName: "Ivy Clark",
    subject: "Physics",
    startDate: "2023-05-09",
    endDate: "2024-02-05",
    status: "Ended",
    amountEarned: 812.34,
    classes: 14,
    rating: 4.7,
  },
  {
    clientName: "Jack King",
    subject: "Geography",
    startDate: "2023-03-25",
    endDate: "2023-12-11",
    status: "Active",
    amountEarned: 394.55,
    classes: 9,
    rating: 4.1,
  },
  {
    clientName: "Mendy Bahago",
    subject: "Mathematics",
    startDate: "2023-05-12",
    endDate: "2024-02-18",
    status: "Ended",
    amountEarned: 876.45,
    classes: 12,
    rating: 4.5,
  },
  {
    clientName: "Benard Simon",
    subject: "Science",
    startDate: "2023-03-20",
    endDate: "2023-11-11",
    status: "Active",
    amountEarned: 432.99,
    classes: 8,
    rating: 4.8,
  },
  {
    clientName: "Alice Williams",
    subject: "History",
    startDate: "2023-06-01",
    endDate: "2024-04-05",
    status: "Pending",
    amountEarned: 275.32,
    classes: 15,
    rating: 3.9,
  },
  {
    clientName: "Bob Jones",
    subject: "Literature",
    startDate: "2023-02-10",
    endDate: "2023-12-24",
    status: "Cancelled",
    amountEarned: 123.45,
    classes: 5,
    rating: 2.7,
  },
  {
    clientName: "Charlie Brown",
    subject: "Art",
    startDate: "2023-08-18",
    endDate: "2024-06-30",
    status: "Ended",
    amountEarned: 654.75,
    classes: 10,
    rating: 4.2,
  },
  {
    clientName: "Karen Lewis",
    subject: "Economics",
    startDate: "2023-07-18",
    endDate: "2024-03-15",
    status: "Pending",
    amountEarned: 301.22,
    classes: 16,
    rating: 3.8,
  },
  {
    clientName: "Liam White",
    subject: "Philosophy",
    startDate: "2023-02-20",
    endDate: "2024-01-05",
    status: "Cancelled",
    amountEarned: 145.67,
    classes: 6,
    rating: 2.5,
  },
  {
    clientName: "Mia Harris",
    subject: "Psychology",
    startDate: "2023-09-01",
    endDate: "2024-07-01",
    status: "Ended",
    amountEarned: 712.89,
    classes: 13,
    rating: 4.4,
  },
  {
    clientName: "Noah Martin",
    subject: "Sociology",
    startDate: "2023-08-25",
    endDate: "2024-06-23",
    status: "Active",
    amountEarned: 432.32,
    classes: 11,
    rating: 4.2,
  },
  {
    clientName: "Olivia Thompson",
    subject: "Anthropology",
    startDate: "2023-01-30",
    endDate: "2023-10-20",
    status: "Pending",
    amountEarned: 523.45,
    classes: 19,
    rating: 4.3,
  },
  {
    clientName: "Mendy Bahago",
    subject: "Mathematics",
    startDate: "2023-05-12",
    endDate: "2024-02-18",
    status: "Ended",
    amountEarned: 876.45,
    classes: 12,
    rating: 4.5,
  },
  {
    clientName: "Benard Simon",
    subject: "Science",
    startDate: "2023-03-20",
    endDate: "2023-11-11",
    status: "Active",
    amountEarned: 432.99,
    classes: 8,
    rating: 4.8,
  },
  {
    clientName: "Alice Williams",
    subject: "History",
    startDate: "2023-06-01",
    endDate: "2024-04-05",
    status: "Pending",
    amountEarned: 275.32,
    classes: 15,
    rating: 3.9,
  },
  {
    clientName: "Bob Jones",
    subject: "Literature",
    startDate: "2023-02-10",
    endDate: "2023-12-24",
    status: "Cancelled",
    amountEarned: 123.45,
    classes: 5,
    rating: 2.7,
  },
  {
    clientName: "Charlie Brown",
    subject: "Art",
    startDate: "2023-08-18",
    endDate: "2024-06-30",
    status: "Ended",
    amountEarned: 654.75,
    classes: 10,
    rating: 4.2,
  },
  {
    clientName: "Karen Lewis",
    subject: "Economics",
    startDate: "2023-07-18",
    endDate: "2024-03-15",
    status: "Pending",
    amountEarned: 301.22,
    classes: 16,
    rating: 3.8,
  },
  {
    clientName: "Liam White",
    subject: "Philosophy",
    startDate: "2023-02-20",
    endDate: "2024-01-05",
    status: "Cancelled",
    amountEarned: 145.67,
    classes: 6,
    rating: 2.5,
  },
  {
    clientName: "Mia Harris",
    subject: "Psychology",
    startDate: "2023-09-01",
    endDate: "2024-07-01",
    status: "Ended",
    amountEarned: 712.89,
    classes: 13,
    rating: 4.4,
  },
  {
    clientName: "Noah Martin",
    subject: "Sociology",
    startDate: "2023-08-25",
    endDate: "2024-06-23",
    status: "Active",
    amountEarned: 432.32,
    classes: 11,
    rating: 4.2,
  },
  {
    clientName: "Olivia Thompson",
    subject: "Anthropology",
    startDate: "2023-01-30",
    endDate: "2023-10-20",
    status: "Pending",
    amountEarned: 523.45,
    classes: 19,
    rating: 4.3,
  },
];
